import { Container, Grid } from "@mui/material";
import PayableItemShow from "./PaymentableItemShow";

const PayableItemList = () => {
	return (
		<>
			<Container sx={{ mt: 4 }} maxWidth="xl">
				<Grid
					container
					direction="row"
					justifyContent="center"
					alignItems="stretch"
					spacing={3}
				>
					<Grid item xs={12}>
						<PayableItemShow />
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default PayableItemList;
